module.exports = __webpack_public_path__ + "img/08_NSC_Groesse_iPad_L.adbc8530.jpg";